<template>
  <div class="l-data-board l-rblock" :class="{ 'l-data-board-3': theme == 3, 'l-data-board-2': theme == 2,'l-data-board-4': theme == 4,'l-data-board-5': theme == 5 }"
    v-loading="loading">
    <template v-if="theme == '5'">
      <div style="display: flex;width: 100%;align-items: center;margin-top: 10px;">
        <div v-if="showType == 'icon'" :class="['l-data-board__icon','l-data-board__icon_theme5']"
          :style="{ color: color }">
          <!-- <div class="l-data-board__icon__bg" :style="{ 'background-color': color }"></div> -->
          <i :class="icon"></i>
        </div>
        <div v-if="showType == 'img'" :class="['l-data-board__icon','l-data-board__icon_theme5']">
          <el-image class="img" :src="imgUrl">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
      </div>
      <div v-if="label" class="l-data-board__title">{{ label }}</div>
      <div style="display: flex;width: 100%;justify-content: space-between;align-items: center;">
        <div class="l-data-board__num" :style="{ color: numColor }">
          <l-count-up :end="showValue"></l-count-up>
          <span class="unit">{{ valueDw }}</span>
        </div>
        <div class="l-data-board__des" style="text-align: center;font-size: 12px;">
            
          {{des}}
           <span :style="{ background: flagIconColor }" style="color: #fff;border-radius: 8px;padding: 1px 5px;font-size: 12px;">{{ subValue }}</span>
            <i v-if="flagIcon" :style="{ color: flagIconColor }" :class="['flag-icon', flagIcon]"></i>
        </div>
      </div>
    </template>
    <template v-else-if="theme == '4'">
      <div style="display: flex;width: 100%;align-items: center;margin-top: 10px;">
        <div v-if="showType == 'icon'" :class="['l-data-board__icon','l-data-board__icon_theme4']"
          :style="{ color: color }">
          <div class="l-data-board__icon__bg" :style="{ 'background-color': color }"></div>
          <i :class="icon"></i>
        </div>
        <div v-if="showType == 'img'" :class="['l-data-board__icon','l-data-board__icon_theme4']">
          <el-image class="img" :src="imgUrl">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
        <div v-if="label" class="l-data-board__title">{{ label }}</div>
      </div>
      <div style="display: flex;justify-content: center;">
        <div class="l-data-board__num" :style="{ color: numColor }">
          <l-count-up :end="showValue"></l-count-up>
          <span class="unit">{{ valueDw }}</span>
        </div>
      </div>
        <div v-if="des" class="l-data-board__des" style="text-align: center;">
            
            <i v-if="flagIcon" :style="{ color: flagIconColor }" :class="['flag-icon', flagIcon]"></i>
            {{ des }}
          </div>

    </template>
    <template v-else>
      <div v-if="showType == 'icon' && theme != 3" :class="['l-data-board__icon']" :style="{ 
        color: color, 
        width: `${imgSize}px`, 
        height: `${imgSize}px`,
        'min-width': `${imgSize}px`,
        'font-size': `${(imgSize*(36/64)).toFixed(0)}px`,
      }">
        <div class="l-data-board__icon__bg" :style="{ 'background-color': color }"></div>
        <i :class="icon"></i>
      </div>
      <div v-if="(showType == 'img' && theme != 3) || (imgUrl && theme == 2)" :class="['l-data-board__icon']">
        <el-image class="img" :src="imgUrl" :style="{height: `${(imgSize*(48/64)).toFixed(0)}px`}">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </div>
      <div class="l-data-board__text">
        <div v-if="label && theme != 2" class="l-data-board__title">{{ label }}</div>
        <template v-if="theme == 1 || theme == 2">
          <div class="l-data-board__num" :style="{ color: numColor }">
            <l-count-up :end="showValue"></l-count-up>
            <span class="unit">{{ valueDw }}</span>
          </div>
          <div v-if="theme == 2" class="l-data-board__title">{{ label }}</div>
          <div v-if="des" class="l-data-board__des">
            {{ des }}
            <i v-if="flagIcon" :style="{ color: flagIconColor }" :class="['flag-icon', flagIcon]"></i>
          </div>
        </template>
        <template v-else-if="theme == 3">
          <div class="l-data-board__numlist">
            <div class="l-data-board__numitem">
              <div v-if="title1" class="l-data-board__num-title">{{ title1 }}</div>
              <div class="l-data-board__num" :style="{ color: numColor }">
                <l-count-up :end="showValue"></l-count-up>
                <span class="unit">{{ valueDw }}</span>
              </div>
            </div>
            <div class="l-data-board__numitem">
              <div v-if="title2" class="l-data-board__num-title">{{ title2 }}</div>
              <div class="l-data-board__num" :style="{ color: numColor }">
                <l-count-up :end="showValue1"></l-count-up>
                <span class="unit">{{ valueDw1 }}</span>
              </div>
            </div>
            <div class="l-data-board__numitem">
              <div class="l-data-board__desItem">
                <div class="l-data-board__desItem-border"></div>
                <div class="l-data-board__desItem-border"></div>
                <div class="l-data-board__desItem-border"></div>
                <div class="l-data-board__desItem-border"></div>
                <div class="l-data-board__des-num" :style="{ color: flagIconColor }">
                  {{ subValue }}
                  <i :class="['flag-icon', flagIcon]" :style="{ color: flagIconColor }"></i>
                </div>
                <div class="l-data-board__des">{{ des }}</div>
              </div>
            </div>
          </div>

        </template>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: "l-data-board",
  props: {
    value: [Number, String],
    label: String,
    des: String,

    showType: String,
    icon: String,
    color: String,
    imgUrl: String,
    imgSize: {
      default: 64
    },
    numColor: {
      type: String,
      default: "#5E95FF",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    flagIcon: String,
    flagIconColor: String,
    theme: {
      default: '1'
    },
    title1: {
      default: ''
    },
    title2: {
      default: ''
    },
    value1: {
      default: 0
    },
    subValue: {
      default: ''
    }
  },
  data() {
    return {};
  },
  computed: {
    showValue() {
      let num = this.value;
      if (num && typeof num == "string") {
        if (num.split(/[0-9.]/gi).filter(e => e).length >= 2) {
          return num;
        }
        num = num.replace(/[^0-9.]/gi, "");
      }
      return num;
    },
    valueDw() {
      // ֵ��λ
      if (
        this.value &&
        typeof this.value == "string" &&
        this.value.indexOf(this.showValue + "") > -1
      ) {
        return this.value.replace(this.showValue + "", "");
      }
      return "";
    },
    showValue1() {
      let num = this.value1;
      if (num && typeof num == "string") {
        if (num.split(/[0-9.]/gi).filter(e => e).length >= 2) {
          return num;
        }
        num = num.replace(/[^0-9.]/gi, "");
      }
      return num;
    },
    valueDw1() {
      if (
        this.value1 &&
        typeof this.value1 == "string" &&
        this.value.indexOf(this.showValue1 + "") > -1
      ) {
        return this.value1.replace(this.showValue1 + "", "");
      }
      return "";
    },
  }
};
</script>

<style lang="less">
@import "./index.less";
</style>
